import { decryptData, encryptData, initializeEncryption } from '@/services/dataService';
import { openDB } from 'idb';

const DB_NAME = 'measure-datasee-ai';
const STORE_NAME = 'store';
const VERSION = 1;

let dbPromise = null;

export const IndexedDbService = {
  async getDB() {
    if (!dbPromise) {
      dbPromise = openDB(DB_NAME, VERSION, {
        upgrade(db) {
          if (!db.objectStoreNames.contains(STORE_NAME)) {
            db.createObjectStore(STORE_NAME);
          }
        },
      });
    }
    return dbPromise;
  },

  async ensureReady() {
    await initializeEncryption();
    return this.getDB();
  },

  async getItem(key) {
    try {
      const db = await this.ensureReady();
      const encryptedData = await db.get(STORE_NAME, key);
      if (!encryptedData) return null;
      return decryptData(encryptedData);
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error(`IndexedDB getItem failed for [${key}]:`, error);
      }
      await this.removeItem(key);
      return null;
    }
  },

  async setItem(key, value) {
    try {
      const db = await this.ensureReady();
      const encryptedData = encryptData(value);
      await db.put(STORE_NAME, encryptedData, key);
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error(`IndexedDB setItem failed for [${key}]:`, error);
      }
    }
  },

  async removeItem(key) {
    try {
      const db = await this.getDB();
      await db.delete(STORE_NAME, key);
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error(`IndexedDB removeItem failed for [${key}]:`, error);
      }
    }
  },

  async clear() {
    try {
      const db = await this.getDB();
      const tx = db.transaction(STORE_NAME, 'readwrite');
      await tx.store.clear();
      await tx.done;
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error('IndexedDB clear failed:', error);
      }
    }
  },
};
